/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const LeadStateFilterDefault = `ACTIVE`;

export const LeadStateFilter = zod
  .enum(["ACTIVE", "DELETED", "ALL"])
  .default(LeadStateFilterDefault);

export type LeadStateFilter = zod.input<typeof LeadStateFilter>;
export type LeadStateFilterOutput = zod.output<typeof LeadStateFilter>;
